// SPDX-License-Identifier: AGPL-3.0-or-later

import { Link } from 'react-router';

export function NotFoundRoute() {
  return (
    <div className="app-main">
      <h1>Not found</h1>
      <p className="muted">The page you’re looking for doesn’t exist.</p>
      <Link to="/dashboard">Back to dashboard</Link>
    </div>
  );
}
